import React, { useState, useEffect } from "react";
import {useSubheader} from "../../_metronic/layout";
import axios from "axios";
import dayjs from 'dayjs';
import RealTimeService from "../realtime/RealTimeService";
import { FormattedMessage, useIntl } from "react-intl";


export const ConnectionsPage = () => {
  var intl = useIntl();
  const suhbeader = useSubheader();
  suhbeader.setTitle(intl.formatMessage({
                      id: "SYSTEM.CONNECTION.DATAFLOW.STATUS"
                    }));
  

  const [status, setStatus] = useState(null);
  const [fetching, setFetching] = useState(true);

  const fetchStatus = async () => {
    setFetching(true);
    try {
      const connStatus = await axios.get(`${process.env.REACT_APP_URL}/module/SERV/dataflows`);
      setStatus(connStatus.data);
    } catch {
      setStatus(null);
    }
    setFetching(false);
  }

  useEffect(() => {
    fetchStatus();
  }, []);

  useEffect(() => {
    let timeout = null;
    const subscription = RealTimeService.subscribe("SERV", "STATUS", (data) => {
      if(timeout)
        clearTimeout(timeout);
      timeout = setTimeout(() => { fetchStatus(); }, 250);
    } );

    return subscription.unsubscribe;
  }, [])

  return (
  <>
    <div className="card card-custom gutter-b">
      <div className="card-header border-0 py-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label font-weight-bolder text-dark">
            <FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.STATUS"/> 
          </span>
          {/* <span className="text-muted mt-3 font-weight-bold font-size-sm">Dataflows Connection Status</span> */}
        </h3>
      </div>
      <div className="card-body pt-0 pb-3">
        { !fetching && status === null && (
          <div className="alert alert-custom alert-danger fade show mb-5" role="alert">
            <div className="alert-icon"><i className="flaticon-warning"></i></div>
            <div className="alert-text">
              <FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.UNABLE"/>    
            </div>
          </div>
        )}
        <div className="table-responsive">
          <table className="table table-borderless table-vertical-top">
              { status && status.DataflowStatus.map( (df, dfIndex) => (
                <tbody className="mb-5" key={"DF" + dfIndex + "_" + df.Id}>
                    <tr className="table-primary">
                    <td className="text-dark-75 font-weight-bolder d-block font-size-lg">{df.Description}</td>
                    <td></td>
                  </tr>
                  {/* <tr className="text-uppercase text-muted">
                    <th>ORIGIN</th>
                    <th>DESTINATIONS</th>
                  </tr> */}
                  { df.Destinations.map( (d, index) => (
                    <tr key={"dest_" + d.Id + "_" + index}>
                      { index === 0 ? (
                      <td>
                        <span className={`label label-lg label-light-${df.Origin.Status === "CONNECTED" ? "success" : "danger"} label-inline`}>{df.Origin.Status}</span> <span className="text-muted font-weight-bold small">{dayjs(df.Origin.Statistics.ConnectedAt || df.Origin.Statistics.DisconnectedAt).format("DD/MM HH:mm")}</span>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{df.Origin.Description}</span>
                        <span className="text-muted font-weight-bold d-block">
                          {df.Origin.Statistics.TotalMessagesSinceConnected > 0 ? (
                          <> <FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.MESSAGE.RECIVED"/> {df.Origin.Statistics.TotalMessagesSinceConnected}</>
                          ) : (<><FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.NO.MESSAGE.RECIVED"/> </>)}
                        </span>

                        {df.Origin.Statistics.LastMessageAt && (
                        <span className="text-muted font-weight-bold d-block"><FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.LAST.MESSAGE"/> {dayjs(df.Origin.Statistics.LastMessageAt).format("HH:mm")}</span>
                        )}
                      </td>
                      ) : (<td></td>)}
                      
                      <td>
                        <span className={`label label-lg label-light-${d.Status === "CONNECTED" ? "success" : "danger"} label-inline`}>{d.Status}</span> <span className="text-muted font-weight-bold small">{dayjs(d.Statistics.ConnectedAt || d.Statistics.DisconnectedAt).format("DD/MM HH:mm")}</span>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{d.Description}</span>
                        <span className="text-muted font-weight-bold d-block">
                          {d.Statistics.TotalMessagesSinceConnected > 0 ? (
                          <><FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.MESSAGE.SENT"/> {d.Statistics.TotalMessagesSinceConnected}</>
                          ) : (<><FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.NO.MESSAGE.SENT"/></>)}
                        </span>

                        {d.Statistics.LastMessageAt && (
                        <span className="text-muted font-weight-bold d-block"><FormattedMessage id="SYSTEM.CONNECTION.DATAFLOW.LAST.MESSAGE"/> {dayjs(d.Statistics.LastMessageAt).format("HH:mm")}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                  
                  <tr>
                    <td colSpan={2}></td>
                  </tr>
                </tbody>

              ))}
              
          </table>
        </div>
      </div>
    </div>

  </>);
};
